import React from 'react';
import { ComponentWrapper } from '../../helperComponents/componentWrapper/ComponentWrapper';
import { View } from 'react-native';
import { Header } from './Shared/Header';
import { AnalyticsGrid } from './components/analytics/AnalyticsGrid';
import { UserBehavior } from './components/analytics/UsersBehavior';

const Analytics = () => {
    return (
        <ComponentWrapper
            containerStyle={{ flex: 1, backgroundColor: '#F8F8F8', overflow: 'scroll' }}
        >
            <Header />
            <View style={{ paddingHorizontal: 20 }}>
                <AnalyticsGrid />
                <UserBehavior />
            </View>

        </ComponentWrapper>
    );
};

export { Analytics };
